import type { DocumentNode } from 'graphql'
import gql from 'graphql-tag'

const fetchSubscriptionsAccount: DocumentNode = gql`
  query FetchSubscriptionsAccount {
    fetchSubscriptionsAccount {
      ... on Account {
        firstName
        lastName
        billingInfo {
          address {
            postalCode
            country
          }
          paymentMethod {
            cardType
            lastFour
            expYear
            expMonth
            object
          }
        }
      }
      ... on AccountNotFound {
        error {
          type
          message
        }
      }
    }
  }
`

export default fetchSubscriptionsAccount
